import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ClientRange, ClientRangeFormValues, Turnover } from '../../../types';
import { corporateClientsRiskApi } from '../services';

export interface CorporateClientsRiskVolumesFormState {
  isLoading: boolean;
  formValues?: ClientRangeFormValues;
  itemId?: string;
  requestInProgress: boolean;
  submitSuccess?: boolean;
  item?: Turnover;
  type?: string;
}

const initialState: CorporateClientsRiskVolumesFormState = {
  isLoading: true,
  requestInProgress: false,
};

export const corporateClientsRiskVolumesFormStateSlice = createSlice({
  name: 'corporateClientsRiskVolumesFormState',
  initialState,
  reducers: {
    clearIndividualTurnoverFormState: (state) => {
      state.requestInProgress = false;
      state.formValues = undefined;
      state.submitSuccess = undefined;
      state.itemId = undefined;
      state.item = undefined;
      state.isLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      corporateClientsRiskApi.endpoints.getCorporateVolume.matchFulfilled,
      (state, action: PayloadAction<{ data: ClientRange }>) => {
        state.formValues = {
          type: action.payload.data.type,
          from: action.payload.data.from,
          riskScore: action.payload.data.riskScore,
          clientType: 'CORPORATE',
          active: action.payload.data.active,
        };
      },
    );
    builder.addMatcher(
      corporateClientsRiskApi.endpoints.updateCorporateVolumes.matchFulfilled,
      (state, action: PayloadAction<{ data: ClientRange }>) => {
        state.formValues = {
          type: action.payload.data.type,
          from: action.payload.data.from,
          riskScore: action.payload.data.riskScore,
          clientType: 'CORPORATE',
          active: action.payload.data.active,
        };
      },
    );
  },
});

export const { clearIndividualTurnoverFormState } =
  corporateClientsRiskVolumesFormStateSlice.actions;

export default corporateClientsRiskVolumesFormStateSlice.reducer;
